import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SidebarState {
  isSidebarCollapsed: boolean;
}

const initialState: SidebarState = {
  isSidebarCollapsed: false,
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.isSidebarCollapsed = !state.isSidebarCollapsed;
    },
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.isSidebarCollapsed = action.payload;
    },
    closeSidebar: (state) => {
      state.isSidebarCollapsed = true;
    },
    openSidebar: (state) => {
      state.isSidebarCollapsed = false;
    },
  },
});

export const { toggleSidebar, setSidebarCollapsed, closeSidebar, openSidebar } =
  sidebarSlice.actions;
export default sidebarSlice.reducer;
